export const I18N_KEYS_INFO = [
  {
    index: 0,
    title: 'SQ9007',
    content: 'Y9037'
  },
  {
    index: 1,
    title: 'Y9036',
    content: 'Y9035'
  },
  {
    index: 2,
    title: 'SQ1320',
    content: 'Y1511'
  },
  {
    index: 3,
    title: 'SQ1321',
    content: 'Y1512'
  },
  {
    index: 4,
    title: 'Y9040',
    content: 'Y9041'
  },
  {
    index: 5,
    title: 'SQ9001',
    content: 'Y1514'
  },
  {
    index: 6,
    title: 'SQ7001',
    content: 'Y1515'
  },
  // 成绩预测
  {
    index: 7,
    title: 'Y1301',
    content: 'Y1516'
  },
  // 个人记录
  {
    // 从 2024年11月14日 开始用 name 代替数字 index
    index: 'personal-record',
    title: 'Y9099',
    content: 'Y9098'
  },
  {
    index: 8,
    title: 'SQ1322',
    content: 'Y1517'
  },
  // 运动记录
  {
    index: 9,
    title: 'SQ4001',
    content: 'Y1518'
  },
  {
    index: 10,
    title: 'H1101',
    content: 'Y1519'
  },
  {
    index: 11,
    title: 'TD1065',
    content: 'R9026'
  },
  {
    index: 12,
    title: 'Y9061',
    content: 'Y9075'
  }
];
